import { endOfDay, sub } from 'date-fns';
import { useState } from 'react';
import { DateRange } from 'react-day-picker';
import { DateRangeState } from '@/Domain/types/DateRange.types';

export const useDateRangeControls = () => {
  const defaultEnd = endOfDay(new Date());
  const defaultStart = endOfDay(sub(defaultEnd, { days: 6 }));

  const [range, setRange] = useState<DateRangeState>({
    startDate: defaultStart,
    endDate: defaultEnd,
  });

  const handleRangeChange = (dateRange: DateRange | undefined) => {
    if (dateRange?.from && dateRange?.to) {
      setRange({
        startDate: dateRange.from,
        endDate: dateRange.to,
      });
    }
  };

  return {
    range,
    handleRangeChange,
  };
};
